import { render, staticRenderFns } from "./ClientGroupListAddNew.vue?vue&type=template&id=c19c5ad0&"
import script from "./ClientGroupListAddNew.vue?vue&type=script&lang=js&"
export * from "./ClientGroupListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ClientGroupListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports